export default {
    "ajs.datepicker.localisations.day-names.sunday": "Sunday",
    "ajs.datepicker.localisations.day-names.monday": "Monday",
    "ajs.datepicker.localisations.day-names.tuesday": "Tuesday",
    "ajs.datepicker.localisations.day-names.wednesday": "Wednesday",
    "ajs.datepicker.localisations.day-names.thursday": "Thursday",
    "ajs.datepicker.localisations.day-names.friday": "Friday",
    "ajs.datepicker.localisations.day-names.saturday": "Saturday",
    "ajs.datepicker.localisations.day-names-min.sunday": "Sun",
    "ajs.datepicker.localisations.day-names-min.monday": "Mon",
    "ajs.datepicker.localisations.day-names-min.tuesday": "Tue",
    "ajs.datepicker.localisations.day-names-min.wednesday": "Wed",
    "ajs.datepicker.localisations.day-names-min.thursday": "Thu",
    "ajs.datepicker.localisations.day-names-min.friday": "Fri",
    "ajs.datepicker.localisations.day-names-min.saturday": "Sat",
    "ajs.datepicker.localisations.first-day": 1,
    "ajs.datepicker.localisations.is-RTL": false,
    "ajs.datepicker.localisations.month-names.january": "January",
    "ajs.datepicker.localisations.month-names.february": "February",
    "ajs.datepicker.localisations.month-names.march": "March",
    "ajs.datepicker.localisations.month-names.april": "April",
    "ajs.datepicker.localisations.month-names.may": "May",
    "ajs.datepicker.localisations.month-names.june": "June",
    "ajs.datepicker.localisations.month-names.july": "July",
    "ajs.datepicker.localisations.month-names.august": "August",
    "ajs.datepicker.localisations.month-names.september": "September",
    "ajs.datepicker.localisations.month-names.october": "October",
    "ajs.datepicker.localisations.month-names.november": "November",
    "ajs.datepicker.localisations.month-names.december": "December",
    "ajs.datepicker.localisations.show-month-after-year": false,
    "ajs.datepicker.localisations.year-suffix": null
}
